import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { Wrapper } from 'src/domains/players/webview/components/Account/limitsTab/LimitsTab.style';
import { PlayBreakProcedure } from 'src/domains/players/webview/components/Account/limitsTab/playBreakProcedure/PlayBreakProcedure';
import { RealityCheck } from 'src/domains/players/webview/components/Account/limitsTab/realityCheck/RealityCheck';
import { SelfExclusionProcedure } from 'src/domains/players/webview/components/Account/limitsTab/selfExclusionProcedure/SelfExclusionProcedure';
import { AccountReview } from './accountReview/AccountReview';
import { DepositLimitsProcedure } from './rollingNetDepositLimit/DepositLimitsProcedure';

export const LimitsTab = observer('LimitsTab', () => {
    return (
        <Wrapper>
            <DepositLimitsProcedure />
            <PlayBreakProcedure />
            <SelfExclusionProcedure />
            <RealityCheck />
            <AccountReview />
        </Wrapper>
    );
});
